<!--
// nuxt-ui/components/Shared/stats/SidebarMenuStats.vue
-->
<script setup lang="ts">
import { useRegions } from "~/nuxt-ui/Shared/composables/regions";
import { initDropdowns } from "flowbite";
import { useCompetitionStore } from "~/nuxt-ui/stores/competitionStore";

type Props = {
  isBlocked: boolean;
  newStats: boolean;
  seasonId?: number;
};

const props = defineProps<Props>();

const localePath = useLocalePath();
const { regionParam, isNations } = useRegions();
const { currentSeason } = useCompetitionStore();
const route = useRoute();

const activePage = ref<string>("");

const toQueries = (name: string) => {
  const queries = route.query;
  return {
    name,
    params: { region: regionParam },
    query: queries,
  };
};

onMounted(async () => {
  const navItemsDropdown = document.querySelectorAll(".nav-stats-item-dropdown");

  if (navItemsDropdown) {
    let activeItem;
    navItemsDropdown.forEach(item => {
      if (item.classList.contains("router-link-active")) {
        activeItem = item ? item : undefined;
      }
    });
    activePage.value = activeItem ? activeItem.innerText : "-";
  }

  initDropdowns();
});
</script>

<template>
  <div class="hidden lg:block sticky top-40">
    <nav class="pr-0 lg:pr-4">
      <ul class="flex flex-col gap-1" v-if="newStats">
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-Stats'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              {{ $t("stats.sidebar.menu.overview") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-GoalsGrouped'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              {{ $t("stats.sidebar.menu.goals") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Shots'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              {{ $t("stats.sidebar.menu.shots") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Passing'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              {{ $t("stats.sidebar.menu.passing") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Offensives'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              {{ $t("stats.sidebar.menu.offensives") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Defensives'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              {{ $t("stats.sidebar.menu.defensives") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Goalkeeper'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              {{ $t("stats.sidebar.menu.goalkeeper") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Cards'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              {{ $t("stats.sidebar.menu.cards") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Expected'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              {{ $t("stats.sidebar.menu.expected") }}
            </p>
          </nuxt-link>
        </li>
        <!--        <li class="min-w-full">-->
        <!--          <nuxt-link-->
        <!--            :to="localePath(toQueries('region-stats-Approx'))"-->
        <!--            active-class="menu-stats-active"-->
        <!--            class="nav-stats-item"-->
        <!--          >-->
        <!--            {{ $t("stats.sidebar.menu.approx") }}-->
        <!--          </nuxt-link>-->
        <!--        </li>-->
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Mvp'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              <span
                v-if="
                  seasonId === currentSeason?.id &&
                  currentSeason &&
                  currentSeason.metaInformation?.stats_partner
                "
                >{{ currentSeason.metaInformation?.stats_partner?.name }}</span
              >

              {{ $t("stats.sidebar.menu.mvps") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full" v-if="!isNations">
          <nuxt-link
            :to="localePath(toQueries('region-stats-TurnMvp'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              <span
                v-if="
                  seasonId === currentSeason?.id &&
                  currentSeason &&
                  currentSeason.metaInformation?.stats_partner
                "
                >{{ currentSeason.metaInformation?.stats_partner?.name }}</span
              >
              {{ $t("stats.sidebar.menu.turnMvps") }}
            </p>
          </nuxt-link>
        </li>
        <!--        <li class="min-w-full">-->
        <!--          <nuxt-link-->
        <!--            :to="localePath(toQueries('region-stats-Others'))"-->
        <!--            active-class="menu-stats-active"-->
        <!--            class="nav-stats-item"-->
        <!--          >-->
        <!--            {{ $t("stats.sidebar.menu.others") }}-->
        <!--          </nuxt-link>-->
        <!--        </li>-->
      </ul>
      <!--      OLD STATS-->
      <ul class="flex flex-col gap-1" v-if="!newStats">
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-Stats'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              {{ $t("stats.sidebar.menu.overview") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Mvp'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>
              {{ $t("stats.sidebar.menu.mvps") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full" v-if="!isBlocked && !isNations">
          <nuxt-link
            :to="localePath(toQueries('region-stats-TurnMvp'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>{{ $t("stats.sidebar.menu.turnMvps") }}</p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Goals'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>{{ $t("stats.sidebar.menu.goals") }}</p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Assists'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>{{ $t("stats.sidebar.menu.assists") }}</p>
          </nuxt-link>
        </li>
        <li class="min-w-full" v-if="!isBlocked">
          <nuxt-link
            :to="localePath(toQueries('region-stats-BestGoalkeeper'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>{{ $t("stats.sidebar.menu.bestGoalkeeper") }}</p>
          </nuxt-link>
        </li>
        <li class="min-w-full" v-if="!isBlocked">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Cards'))"
            active-class="menu-stats-active"
            class="nav-stats-item"
          >
            <p>{{ $t("stats.sidebar.menu.cards") }}</p>
          </nuxt-link>
        </li>
      </ul>
    </nav>
  </div>

  <div class="block lg:hidden">
    <button
      id="menuStatsNav"
      data-dropdown-toggle="dropdownStatsNav"
      class="rounded-md bg-gray-800 px-4 py-3.5 flex justify-between items-center min-w-full"
      type="button"
    >
      {{ activePage }}
      <svg
        class="w-2 h-2 ml-1"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 10 6"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="m1 1 4 4 4-4"
        />
      </svg>
    </button>
    <!-- Dropdown menu -->
    <div
      id="dropdownStatsNav"
      class="z-30 hidden rounded-lg shadow text-left bg-gray-900 border border-gray-700 py-2 w-3/4"
    >
      <ul class="flex flex-col gap-1" v-if="newStats" aria-labelledby="menuStatsNav">
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-Stats'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.overview')"
          >
            {{ $t("stats.sidebar.menu.overview") }}
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-GoalsGrouped'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.goals')"
          >
            {{ $t("stats.sidebar.menu.goals") }}
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Shots'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.shots')"
          >
            {{ $t("stats.sidebar.menu.shots") }}
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Passing'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.passing')"
          >
            {{ $t("stats.sidebar.menu.passing") }}
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Offensives'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.offensives')"
          >
            {{ $t("stats.sidebar.menu.offensives") }}
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Defensives'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.defensives')"
          >
            {{ $t("stats.sidebar.menu.defensives") }}
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Goalkeeper'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.goalkeeper')"
          >
            {{ $t("stats.sidebar.menu.goalkeeper") }}
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Cards'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.cards')"
          >
            {{ $t("stats.sidebar.menu.cards") }}
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Expected'))"
            active-class="menu-stats-active"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.expected')"
          >
            {{ $t("stats.sidebar.menu.expected") }}
          </nuxt-link>
        </li>
        <!--        <li class="min-w-full">-->
        <!--          <nuxt-link-->
        <!--            :to="localePath(toQueries('region-stats-Approx'))"-->
        <!--            class="nav-stats-item-dropdown"-->
        <!--            @click="activePage = $t('stats.sidebar.menu.approx')"-->
        <!--          >-->
        <!--            {{ $t("stats.sidebar.menu.approx") }}-->
        <!--          </nuxt-link>-->
        <!--        </li>-->
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Mvp'))"
            class="nav-stats-item-dropdown"
            @click="
              seasonId === currentSeason?.id && currentSeason && currentSeason.metaInformation?.stats_partner
                ? (activePage =
                    currentSeason?.metaInformation?.stats_partner?.name + ' ' + $t('stats.sidebar.menu.mvps'))
                : (activePage = $t('stats.sidebar.menu.mvps'))
            "
          >
            <span
              v-if="
                seasonId === currentSeason?.id &&
                currentSeason &&
                currentSeason.metaInformation?.stats_partner
              "
              >{{ currentSeason.metaInformation?.stats_partner?.name }}</span
            >
            {{ $t("stats.sidebar.menu.mvps") }}
          </nuxt-link>
        </li>
        <li class="min-w-full" v-if="!isNations">
          <nuxt-link
            :to="localePath(toQueries('region-stats-TurnMvp'))"
            class="nav-stats-item-dropdown"
            @click="
              seasonId === currentSeason?.id && currentSeason && currentSeason.metaInformation?.stats_partner
                ? (activePage =
                    currentSeason?.metaInformation?.stats_partner?.name +
                    ' ' +
                    $t('stats.sidebar.menu.turnMvps'))
                : (activePage = $t('stats.sidebar.menu.turnMvps'))
            "
          >
            <span
              v-if="
                seasonId === currentSeason?.id &&
                currentSeason &&
                currentSeason.metaInformation?.stats_partner
              "
              >{{ currentSeason.metaInformation?.stats_partner?.name }}</span
            >
            {{ $t("stats.sidebar.menu.turnMvps") }}
          </nuxt-link>
        </li>
        <!--        <li class="min-w-full">-->
        <!--          <nuxt-link-->
        <!--            :to="localePath(toQueries('region-stats-Others'))"-->
        <!--            class="nav-stats-item-dropdown"-->
        <!--            @click="activePage = $t('stats.sidebar.menu.others')"-->
        <!--          >-->
        <!--            {{ $t("stats.sidebar.menu.others") }}-->
        <!--          </nuxt-link>-->
        <!--        </li>-->
      </ul>

      <!--      OLD STATS-->
      <ul class="text-sm text-gray-400" v-if="!newStats" aria-labelledby="menuStatsNav">
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-Stats'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.overview')"
          >
            <p>{{ $t("stats.sidebar.menu.overview") }}</p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Mvp'))"
            class="nav-stats-item-dropdown"
            @click="activePage = 'MVP'"
          >
            <p>{{ $t("stats.sidebar.menu.mvps") }}</p>
          </nuxt-link>
        </li>
        <li class="min-w-full" v-if="!isBlocked && !isNations">
          <nuxt-link
            :to="localePath(toQueries('region-stats-TurnMvp'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.turnMvps')"
          >
            <p>{{ $t("stats.sidebar.menu.turnMvps") }}</p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Goals'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.goals')"
          >
            <p>{{ $t("stats.sidebar.menu.goals") }}</p>
          </nuxt-link>
        </li>
        <li class="min-w-full">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Assists'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.assists')"
          >
            <p>
              {{ $t("stats.sidebar.menu.assists") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full" v-if="!isBlocked">
          <nuxt-link
            :to="localePath(toQueries('region-stats-BestGoalkeeper'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.bestGoalkeeper')"
          >
            <p>
              {{ $t("stats.sidebar.menu.bestGoalkeeper") }}
            </p>
          </nuxt-link>
        </li>
        <li class="min-w-full" v-if="!isBlocked">
          <nuxt-link
            :to="localePath(toQueries('region-stats-Cards'))"
            class="nav-stats-item-dropdown"
            @click="activePage = $t('stats.sidebar.menu.cards')"
          >
            <p>
              {{ $t("stats.sidebar.menu.cards") }}
            </p>
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.nav-stats-item {
  @apply bg-gray-800 rounded-md text-gray-300 text-sm px-4 py-3.5 hover:bg-primary hover:text-black block;
}

.nav-stats-item-dropdown {
  @apply text-gray-300 text-sm px-4 py-3.5 hover:bg-primary hover:text-black block;
}
</style>
